import { render, staticRenderFns } from "./new_daily_item_quick.vue?vue&type=template&id=4ce39af5&scoped=true"
import script from "./new_daily_item_quick.vue?vue&type=script&lang=js"
export * from "./new_daily_item_quick.vue?vue&type=script&lang=js"
import style0 from "./new_daily_item_quick.vue?vue&type=style&index=0&id=4ce39af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce39af5",
  null
  
)

export default component.exports